import { render, staticRenderFns } from "./ProductDetailCard.vue?vue&type=template&id=c6312110&"
import script from "./ProductDetailCard.vue?vue&type=script&lang=js&"
export * from "./ProductDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailCard.vue?vue&type=style&index=0&id=c6312110&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports